import { BrowserUtil } from "./../../../utils/BrowserUtil";
import { CommandController } from "./../../../commanding/CommandController";
import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";
import { BasicController } from "../BasicController";
import { BasicPaymentShopClickTrackingVO } from "./tracking/vo/BasicPaymentShopClickTrackingVO";
import { AddExtraCurrencyVO } from "./vo/AddExtraCurrencyVO";
import { PathProvider } from "../../environment/providers/PathProvider";
import { BasicModel } from "../../model/BasicModel";
import { BasicLayoutManager } from "../../view/BasicLayoutManager";

import { URLRequest, ExternalInterface } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";

import BitmapData = createjs.BitmapData;
import Stage = createjs.Stage;
import BlurFilter = createjs.BlurFilter;
import Bitmap = createjs.Bitmap;

import { SimpleCommand } from "../../../commanding/SimpleCommand";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("CoreJS.BasicAddExtraCurrencyCommand");

export class BasicAddExtraCurrencyCommand extends SimpleCommand {
    protected paymentHash: string;
    protected sessionId: number;

    public execute(commandVars: any = null): void {
        // We need to be sure, that user is logged in the game
        if (!BasicModel.sessionData.loggedIn) {
            return;
        }

        // sessionId is used as a shop-key in the link and tracked in GamePaymentShopClickEvent.
        // aka clientTime
        // aka shopId
        this.sessionId = this.currentUnixTime;

        let currentHash: string;
        let clickSourceId: number = 0;
        let shopTab: number = 0;

        // To be sure, that new "Tracking of the shop click source" feature don't break any shop functionality of the legacy games,
        // AddExtraCurrency command can be use with a paymentHash (as earlier).
        if (!commandVars) {
            currentHash = "";
        } else if (commandVars instanceof AddExtraCurrencyVO) {
            currentHash = commandVars.paymentHash;
            clickSourceId = int(commandVars.clickSourceId);
            shopTab = int(commandVars.shopTab);
        } else {
            currentHash = commandVars.toString();
        }

        this.paymentHash = currentHash;

        // GamePaymentShopClickEvent fires, if user clicks on the shop-button.
        CommandController.instance.executeCommand(BasicController.COMMAND_TRACK_GAME_PAYMENT_SHOP_CLICK_EVENT, new BasicPaymentShopClickTrackingVO(this.sessionId, clickSourceId));

        this.layoutManager.revertFullscreen();

        logger.debug("Use shop in Social Network? " + this.env.requestPayByJS);

        //use Shop in SocialNetwork
        if (this.env.requestPayByJS) {
            this.onOpenPaymentByJS();
        } else { //use WWW Shop
            /* generating single hash format coming from shop and server */
            let urlRequest: URLRequest = new URLRequest(PathProvider.instance.shopURL + this.paymentHash);
            let urlVariables: any = { sid: this.sessionId };

            if (shopTab > 0) {
                urlVariables.t = shopTab;
            }

            urlRequest.data = urlVariables;

            this.onOpenPayment(urlRequest);
        }
    }

    private onOpenPaymentByJS(): void {
        ExternalInterface.call("requestPayment");
    }

    /**
     *    open Paymentshop
     */
    private onOpenPayment(urlRequest: URLRequest): void {
        BrowserUtil.openWindow(urlRequest);
    }

    // TODO: Isn't there a global util class for retrieving the unix time?
    private get currentUnixTime(): number {
        let dateStamp: Date = new Date();
        return Date.UTC(dateStamp.getUTCFullYear(), dateStamp.getUTCMonth(), dateStamp.getUTCDate(), dateStamp.getUTCHours(), dateStamp.getUTCMinutes(), dateStamp.getUTCSeconds(), dateStamp.getUTCMilliseconds()).valueOf();
    }

    private get layoutManager(): BasicLayoutManager {
        return BasicLayoutManager.getInstance();
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}
